@if (!authorization()) {
  <router-outlet/>
}

@if (debug) {
  <core-debug/>
}
